import { render, staticRenderFns } from "./rescind.vue?vue&type=template&id=407cfc22&"
import script from "./rescind.vue?vue&type=script&lang=ts&"
export * from "./rescind.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "rescind.vue"
export default component.exports